import { render, staticRenderFns } from "./JobBoardFormSavoirEtreSection.vue?vue&type=template&id=30682689&scoped=true&"
import script from "./JobBoardFormSavoirEtreSection.vue?vue&type=script&lang=ts&"
export * from "./JobBoardFormSavoirEtreSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30682689",
  null
  
)

export default component.exports